import { BasicSelectField } from 'lib/iterable-hook-form';
import { getCapInputId } from 'modules/frequencyManagement/commonUtils';
import { lowerCaseMessageMedium } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { useFocusOnMount } from 'modules/frequencyManagement/contexts/FocusContext';
import {
  FrequencyMode,
  FrequencyPeriod,
  SupportedMediums,
} from 'modules/frequencyManagement/lib/types';
import { LABEL_BY_PERIOD } from '../../lib/constants';
import { Body2NoMargin } from '../Content.styles';
import { ConnectedFormField } from '../connectedFormField/ConnectedFormField';
import { InlineFlex, InputFieldFixedWidth } from './FixedCap.styles';
import { CAPPING_PERIOD, CAPPING_MAX_ALLOWED, SchemaFormKeys } from '../../contexts/FormProvider';

const createOption = (period: FrequencyPeriod) => ({
  /**
   * NOTE: Update to accommodate MessageType
   */
  id: `medium-${period}`,
  label: LABEL_BY_PERIOD[period],
  value: period,
});

export const FixedCap = ({
  rootName,
  messageMedium,
}: {
  rootName?: string;
  messageMedium: SupportedMediums;
}) => {
  const inputName = rootName ? `${rootName}.${CAPPING_MAX_ALLOWED}` : CAPPING_MAX_ALLOWED;
  const selectName = rootName ? `${rootName}.${CAPPING_PERIOD}` : CAPPING_PERIOD;

  useFocusOnMount(FrequencyMode.Cap, rootName);

  return (
    <ConnectedFormField labelText="Message maximum" name={inputName as SchemaFormKeys}>
      <InlineFlex>
        <Body2NoMargin>Send no more than</Body2NoMargin>
        <InputFieldFixedWidth
          id={getCapInputId(rootName)}
          name={inputName}
          type="number"
          valueAsNumber
        />
        <Body2NoMargin>{lowerCaseMessageMedium(messageMedium)} messages per</Body2NoMargin>
        <BasicSelectField
          name={selectName}
          options={[FrequencyPeriod.Daily, FrequencyPeriod.Weekly, FrequencyPeriod.Monthly].map(
            createOption,
          )}
        />
        <Body2NoMargin>per user.</Body2NoMargin>
      </InlineFlex>
    </ConnectedFormField>
  );
};
